import { FieldInfo } from '../../EmployeeData';
import { PositionChangeData } from './components/positionChange/types';
import { SalaryChangeData } from './components/salaryChange/types';

export type RecordField = {
  fieldInfo: FieldInfo;
  value: string | null;
};

export const employeeObjectApiName = 'flair__Employee__c';

/* eslint-disable no-unused-vars */
export enum StepType {
  SelectForm = 'selectForm',
  SelectEmployee = 'selectEmployee',
  ReasonFiles = 'reasonFiles',
  Position = 'position',
  Salary = 'salary',
  EmployeeDetails = 'employeeDetails',
  Review = 'review',
}

export type RequestFormMode = 'employee' | 'manager';

export type RequestFormProps = {
  show: boolean;
  recordType: string;
  showAllRequests: boolean;
  onHide: () => void;
};

export type RequestFormData = {
  requestFormId?: string | null;
  employeeId?: string | null;
  reason?: string;
  files?: File[];
  fields?: { [key: string]: string };
  salaryChange?: SalaryChangeData;
  positionChange?: PositionChangeData;
};
